import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=7f08355f&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"
import style0 from "./page3.vue?vue&type=style&index=0&id=7f08355f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08355f",
  null
  
)

export default component.exports